import { z } from 'zod';

const APPROVAL_STATUSES = ['', 'PENDING', 'APPROVED', 'REJECTED', 'CANCELLED'] as const;

/** 운영 목록 / 내 결재 검색 필터 스키마 */
export const approvalSearchSchema = z
  .object({
    status: z.enum(APPROVAL_STATUSES).optional(),
    formCode: z.string().max(64).optional(),
    requester: z.string().max(64).optional(),
    workflowName: z.string().max(64).optional(),
    from: z.string().optional(),
    to: z.string().optional(),
    keyword: z.string().max(200).optional(),
    page: z.number().int().min(0).optional(),
    size: z.number().int().min(1).max(100).optional(),
    sort: z.string().optional(),
  })
  .refine(
    (v) => {
      if (v.from && v.to) {
        return new Date(v.from) <= new Date(v.to);
      }
      return true;
    },
    { message: '시작일은 종료일보다 이전이어야 합니다', path: ['from'] }
  );

export type ApprovalSearchFormValues = z.infer<typeof approvalSearchSchema>;

/** 결재 상신 폼 스키마 */
export const createApprovalSchema = z.object({
  formCode: z.string().min(1, '양식을 선택하세요').max(64),
  title: z.string().min(1, '제목을 입력하세요').max(200),
  summary: z.string().max(512).optional(),
  formData: z.record(z.unknown()).default({}),
});

export type CreateApprovalFormValues = z.infer<typeof createApprovalSchema>;

/** 승인 의견 스키마 (승인: 선택, 반려: 필수는 사용 측에서 .superRefine 으로 추가) */
export const approvalDecisionSchema = z.object({
  comment: z.string().max(512).optional(),
});

export type ApprovalDecisionFormValues = z.infer<typeof approvalDecisionSchema>;

/** 반려 스키마 — 사유 필수 */
export const rejectionDecisionSchema = z.object({
  comment: z.string().min(1, '반려 사유를 입력해주세요').max(512),
});

export type RejectionDecisionFormValues = z.infer<typeof rejectionDecisionSchema>;
